
import common from '../common.js';

export default {
  async loadChangeTrackingByContainer(context, payload ) {
    var url = `changeTracking/byContainer/${payload}`;
    const responseJsonType = await common.getRequest(context, payload, url)
    // const responseDataType = [];
    // for (const key in responseJsonType) 
    // {
    //   const noteType = {
    //     noteTypeId: responseJsonType[key].noteTypeId,
    //     noteTypeName: responseJsonType[key].noteTypeName,
    //   };
    //   responseDataType.push(noteType);        
    // }
    context.commit('setChangeTrackingByContainer', responseJsonType)
  },
}
